
export const getPageTextFields = (page) => {
  const groups = [];

  const push = (group, subgroup, path, text, fieldType) => {
    if (typeof text === "string" && text.trim().length > 0) {
      groups.push({ group, subgroup, path, original: text, fieldType });
    }
  };

  // META
  if (page.meta) {
    if (page.meta.pageTitle?.content) {
      push(
        "Meta",
        "Meta Title",
        "meta.pageTitle",
        page.meta.pageTitle.content,
        page.meta.pageTitle.fieldType
      );
    }
    if (page.meta.pageDescription?.content) {
      push(
        "Meta",
        "Meta Description",
        "meta.pageDescription",
        page.meta.pageDescription.content,
        "metaDescription"
      );
    }
    if (page.meta.socialSharing) {
      push(
        "Meta",
        "Social Sharing Title",
        "meta.socialSharing.title",
        page.meta.socialSharing.title,
        page.meta.socialSharing.fieldType
      );

      push(
        "Meta",
        "Social Sharing Description",
        "meta.socialSharing.description",
        page.meta.socialSharing.description,
        "metaDescription"
      );
    }
  }

  // SECTIONS
  if (Array.isArray(page.sections)) {
    page.sections.forEach((section, si) => {
      const sectionTitle = section.sectionName || `Section ${si + 1}`;

      push(
        sectionTitle,
        "Section Title",
        `sections[${si}].title`,
        section.title?.content,
        section.title?.fieldType
      );

      push(
        sectionTitle,
        "Section Description",
        `sections[${si}].description`,
        section.description?.content,
        section.description?.fieldType
      );

      if (
        section.callToAction?.fieldType &&
        section.callToAction.fieldType !== "none"
      ) {
        push(
          sectionTitle,
          "Section CTA",
          `sections[${si}].callToAction`,
          section.callToAction.content,
          section.callToAction.fieldType
        );
      }

      if (section.sectionType !== "hero" && Array.isArray(section.blocks)) {
        section.blocks.forEach((block, bi) => {
          const blockTitle = block.blockName || `Block ${bi + 1}`;

          push(
            sectionTitle,
            `${blockTitle} - Title`,
            `sections[${si}].blocks[${bi}].title`,
            block.title?.content,
            block.title?.fieldType
          );

          push(
            sectionTitle,
            `${blockTitle} - Text`,
            `sections[${si}].blocks[${bi}].text`,
            block.text?.content,
            block.text?.fieldType
          );

          if (
            block.callToAction?.fieldType &&
            block.callToAction.fieldType !== "none"
          ) {
            push(
              sectionTitle,
              `${blockTitle} - CTA`,
              `sections[${si}].blocks[${bi}].callToAction`,
              block.callToAction.content,
              block.callToAction.fieldType
            );
          }
        });
      }
    });
  }

  return groups;
}

// export const buildTranslationsTree = (values) => {
//   const tree = {};

//   Object.entries(values).forEach(([flatKey, translation]) => {
//     if (!translation) return;

//     const [path, lang] = flatKey.split(".");
//     const parts = path.split(/\.|\[(\d+)\]/g).filter(Boolean);

//     let cursor = tree;

//     for (let i = 0; i < parts.length; i++) {
//       const part = parts[i];
//       const next = parts[i + 1];

//       if (/^\d+$/.test(next)) {
//         cursor[part] = cursor[part] || [];
//         cursor = cursor[part];

//         i++;
//         const arrayIndex = Number(parts[i]);
//         cursor[arrayIndex] = cursor[arrayIndex] || {};
//         cursor = cursor[arrayIndex];
//       } else {
//         cursor[part] = cursor[part] || {};
//         cursor = cursor[part];
//       }
//     }
//     cursor[lang] = translation;
//   });

//   return tree;
// }


export const buildTranslationsTree = (values) => {
  const tree = {};

  Object.entries(values).forEach(([flatKey, translation]) => {
    if (!translation) return;

    // Разделяем ключ на путь и язык
    const lastDot = flatKey.lastIndexOf(".");
    const path = flatKey.substring(0, lastDot);
    const lang = flatKey.substring(lastDot + 1);

    const parts = path.split(/\.|\[(\d+)\]/g).filter(Boolean);

    let cursor = tree;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const next = parts[i + 1];

      // Обработка массивов
      if (/^\d+$/.test(next)) {
        cursor[part] = cursor[part] || [];
        cursor = cursor[part];

        i++;
        const arrayIndex = Number(parts[i]);
        cursor[arrayIndex] = cursor[arrayIndex] || {};
        cursor = cursor[arrayIndex];
      } else {
        cursor[part] = cursor[part] || {};
        cursor = cursor[part];
      }
    }

    // Вставляем перевод языка в конечный узел
    cursor[lang] = translation;
  });

  return tree;
};




export const normalizeTranslations = (translations) => {
  if (!translations || typeof translations !== "object") return translations;
  const normalized = { ...translations };

  if (
    normalized.sections &&
    typeof normalized.sections === "object" &&
    !Array.isArray(normalized.sections)
  ) {
    const maybeArray = normalized.sections["undefined"];
    if (Array.isArray(maybeArray)) {
      normalized.sections = maybeArray;
    }
  }

  if (Array.isArray(normalized.sections)) {
    normalized.sections = normalized.sections.map((sec) => {
      if (!sec || typeof sec !== "object") return sec;
      const newSec = { ...sec };
      if (
        newSec.blocks &&
        typeof newSec.blocks === "object" &&
        !Array.isArray(newSec.blocks) &&
        Array.isArray(newSec.blocks["undefined"])
      ) {
        newSec.blocks = newSec.blocks["undefined"];
      }
      return newSec;
    });
  }

  return normalized;
}

export const parseLandscapeCardText = content => {
  if (!content || typeof content !== 'string') {
    return { subTitle: null, text: null };
  }

  const trimmed = content.trim();
  const markdownBoldMatch = trimmed.match(/^\*\*(.+?)\*\*\s*([\s\S]*)$/);

  if (markdownBoldMatch) {
    const subTitle = markdownBoldMatch[1]?.trim() || null;
    const text = markdownBoldMatch[2]?.trim() || null;
    return { subTitle, text };
  }

  return { subTitle: null, text: trimmed };
};

export const localizePageAssetData = (original, translations, locale) => {
  if (original === null || typeof original !== "object") {
    return original;
  }

  if (Array.isArray(original)) {
    return original.map((item, index) =>
      localizePageAssetData(
        item,
        translations?.[index] ?? {},
        locale
      )
    );
  }

  let result = {};

  Object.keys(original).forEach((key) => {
    const origValue = original[key];
    const transValue = translations?.[key];

    if (
      origValue &&
      typeof origValue === "object" &&
      "fieldType" in origValue
    ) {
      const translatedContent = transValue?.[locale];
      result[key] = {
        ...origValue,
        ...(translatedContent !== undefined &&
        translatedContent !== null &&
        translatedContent !== ''
          ? { content: translatedContent }
          : {}),
      };
    } else {
      result[key] = localizePageAssetData(
        origValue,
        transValue,
        locale
      );
    }
  });

  return result;
}

export const getTranslationValue = (translations, path, locale) => {

  const parts = path.split(/\.|\[(\d+)\]/g).filter(Boolean);
  let cursor = translations;

  for (let part of parts) {
    if (cursor == null) {
      return undefined;
    }
    const index = /^\d+$/.test(part) ? Number(part) : part;
    cursor = cursor[index];
  }

  return cursor?.[locale];
}


export const buildNestedInitialValues = (flatValues) => {
  const nested = {};

  Object.entries(flatValues).forEach(([flatKey, value]) => {
    if (value === "" || value == null) {
      return;
    }

    const parts = flatKey.split(/\.|\[(\d+)\]/g).filter(Boolean);
    let cursor = nested;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      const next = parts[i + 1];

      const isNextIndex = /^\d+$/.test(next);

      if (isNextIndex) {
        // ensure this is array
        cursor[part] = cursor[part] || [];
        cursor = cursor[part];

        // move to index
        i++;
        const index = Number(parts[i]);
        cursor[index] = cursor[index] || {};
        cursor = cursor[index];
      } else {
        // last part?
        if (i === parts.length - 1) {
          cursor[part] = value;
        } else {
          cursor[part] = cursor[part] || {};
          cursor = cursor[part];
        }
      }
    }
  });

  return nested;
}

export const getLocalizedRewildingLandscapes = (
  landingPageData,
  pageTranslations,
  locale
) => {
  if (!landingPageData) {
    return [];
  }

  const userTranslations = normalizeTranslations(pageTranslations || {});
  const localizedPage = localizePageAssetData(landingPageData, userTranslations, locale);

  return (
    localizedPage?.sections?.find(section => section.sectionId === 'rewilding-landscapes')
      ?.blocks || []
  );
};


